<template>
    <v-row justify="center" class="border-radius-3">
        <v-dialog
            v-model="dialog"
            color="#323A46"
            persistent
            :width="$vuetify.breakpoint.xs ? '90%' : '70%'"
            content-class="border-radius-2 pt-0"
            overlay-color="#7764CA"
            overlay-opacity="1"
        >
            <div class="onboarding-logo-wrapper">
                <v-img
                    :src="logo"
                    width="100"
                    class="mx-auto">
                </v-img>
            </div>
            <v-card
                class="custom-card border-radius-2 pa-5 position-relative d-flex justify-center flex-column elevation-6"
                color="#e9f5f4"
            >
                <v-row>
                    <v-col>
                        <v-card-title class=" d-flex justify-center px-15 mb-sm-6 position-relative">
                            <v-img
                                :src="require(`@/assets/img/icons/icon-voice-assistant.svg`)"
                                max-height="40px"
                                max-width="40px"
                                :min-width="$vuetify.breakpoint.xs ? '32' : '40'"
                                :min-height="$vuetify.breakpoint.xs ? '32' : '40'"
                                contain
                                class="main-sound-img-abs cursor-pointer"
                                @click="read"
                            ></v-img>
                            <p  data-cy="greet-welcome-message"
                                class="main-title mb-0 d-flex justify-center"
                                >{{ greetWelcomeMessage }}
                            </p>
                        </v-card-title>
                        <v-card-text class="">
                            <p
                                class="titles font-weight-regular"
                                v-html="$t('initialTour.finish_onboarding')">
                            </p>
                            </v-card-text>
                    </v-col>
                </v-row>

                <v-card-actions class="d-flex justify-center">
                    <v-btn
                        id="finishOnboarding-finish-button"
                        data-cy="finishOnboarding-finish-button"
                        class="bg-gradient-primary px-15 border-radius-1 text-transform-none font-weight-bolder"
                        large
                        dark
                        @click.stop="nextPass">{{
                        $t('initialTour.get_started2')
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
/* eslint-disable global-require */

import { confetti } from 'dom-confetti'
import { mapState, mapActions } from 'vuex'
import { CONFETTI_SETUP } from '@/constants/DefaultConstants'
import DiagnosticService from '@/services/diagnostic'

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            token: (state) => state.token,
        }),
        greetWelcomeMessage() {
            // eslint-disable-next-line no-nested-ternary
            return `${this.$t('initialTour.excellent')}, ${this.$utils.upperFirstLetter(this.user.firstname.split(' ')[0])}!`
        },
    },
    data() {
        return {
            bee_6: require('@/assets/img/bees/bee006.svg'),
            logo: require('@/assets/img/brand/logo.svg'),
            debounced: false,
        }
    },
    methods: {
        ...mapActions('dashboard', ['showFinishOnBoardingModal']),
        async nextPass() {
            if (!this.debounced) {
                this.debounced = true
                const app = document.getElementById('finishOnboarding-finish-button')
                confetti(app, CONFETTI_SETUP)
                const pendingDiagnostics = await DiagnosticService.findDiagnosticoPendiente(this.user.id, true)
                    .catch((error) => console.error(error))
                if (Array.isArray(pendingDiagnostics.content) && pendingDiagnostics.content.length) {
                    alert(this.$t('initialTour.you_have_more_pending_diagnostics'))
                    window.location.href = `${window.location.origin}?token=${this.token}`
                }
                setTimeout(() => {
                    this.showFinishOnBoardingModal()
                    this.debounced = false
                }, 1500)
            }
        },
        read(){
            this.play('finish_onboarding')
        },
        play(text) {
            if (this.audio && !this.audio.paused) {
                this.audio.pause()
            }
            const audio = new Audio(`${process.env.VUE_APP_VOICE_SAMPLE_URL}onboarding/${text}.mp3`);
            audio.play()
                .then(() => {
                    this.audio = audio;
                })
                .catch(() => {
                    this.audio = null;
                });
        },
        getTextFromHTML(html) {
            const div = document.createElement('div')
            div.innerHTML = html
            return div.innerText
        },

    },
}
</script>
<style lang="scss">

.avatar-stars {
    background: url(../../assets/img/effects/avatar-stars.svg) round;
}

.bee-6 {
    top: -8vh;
    right: 25%;
}
.big-bee {
    width: 35vh;
}
.main-title{
    font-size: 1.5em;
    word-break: keep-all;
    @media screen and (max-width: 600px) {
        font-size: 1.2rem;
    }
}
.titles{
    font-size: 1.2rem;
    line-height: 1.4rem;
    color: #323A46;
    text-align: center;
    span{
        color: #7764CA;
    }
}
</style>
